import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Icon = ({ children, name, style, className }) => (
  <StyledIcon {...style} className={`icon ${name} ${className}`}>
    {children}
  </StyledIcon>
);

Icon.propTypes = {
  className: PropTypes.string,
  children: PropTypes.string,
  name: PropTypes.string,
  style: PropTypes.object,
};

Icon.defaultProps = {
  name: '',
  style: {},
};

const StyledIcon = styled.span``;

export default Icon;
